module.exports = __webpack_public_path__ + "assets/sorry.55718100.svg";